import { addPopup, settings } from "./utils"

const auth = () => {
  return 0
}

export default auth
